// Shared formatters + constants for the Scorecard module.
// Local RD convention: no "billones" — everything shown in millions (MM).

export const fmtNum = (n) =>
  new Intl.NumberFormat("es-DO").format(Math.round(n || 0));

export const fmtMoney = (n) =>
  new Intl.NumberFormat("es-DO", {
    style: "currency",
    currency: "DOP",
    maximumFractionDigits: 0,
  }).format(n || 0);

export const fmtMoneyShort = (n) => {
  const v = Math.abs(n || 0);
  if (v >= 1e6) return `RD$${(n / 1e6).toFixed(1)}MM`;
  if (v >= 1e3) return `RD$${(n / 1e3).toFixed(0)}K`;
  return fmtMoney(n);
};

export const PERIODS = [
  { id: "current_month",   label: "Este mes" },
  { id: "current_quarter", label: "Trimestre" },
  { id: "year_to_date",    label: "YTD" },
  { id: "custom",          label: "Rango" },
];

export const isoToday = () => new Date().toISOString().slice(0, 10);

export const MONTHS_ES = ["Ene", "Feb", "Mar", "Abr", "May", "Jun",
                          "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

// Shared palette used across pies and campaign badges.
export const PIE_COLORS = [
  "#f4c400", "#f97316", "#0ea5e9", "#8b5cf6", "#22c55e",
  "#ef4444", "#14b8a6", "#a855f7", "#eab308", "#ec4899",
  "#3b82f6", "#84cc16", "#64748b",
];
